module.exports = __webpack_public_path__ + "static/img/4645_phase_function_Paper_Points.0c7786a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4645_phase_function_Paper_Points.png
// module id = edJD
// module chunks = 0